module.exports = __webpack_public_path__ + "static/media/faraday_logo.3af44fcb.svg";